import React from 'react'

export const IconPlant = (isWhiteIcon?: any) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.745 3.815C6.655 2.42 6.09 1.06 5.03 0C3.96 1.07 3.37 2.43 3.255 3.815C3.895 4.155 4.485 4.595 5 5.13C5.515 4.6 6.105 4.16 6.745 3.815ZM5.025 1.595C5.34 2.11 5.56 2.685 5.675 3.285C5.44 3.435 5.22 3.6 5.005 3.775C4.795 3.605 4.57 3.44 4.34 3.29C4.465 2.69 4.695 2.115 5.025 1.595ZM5 6.725C4.59 6.1 4.07 5.555 3.47 5.125C3.405 5.08 3.335 5.045 3.27 4.995C3.335 5.04 3.405 5.08 3.465 5.12C2.49 4.415 1.295 4 0 4C0 6.66 1.68 8.91 4.015 9.745C4.33 9.86 4.66 9.945 5 10C5.34 9.94 5.665 9.855 5.985 9.745C8.32 8.91 10 6.66 10 4C7.91 4 6.075 5.085 5 6.725ZM5.66 8.8C5.44 8.875 5.22 8.935 4.995 8.985C4.775 8.94 4.56 8.88 4.355 8.805C2.71 8.215 1.505 6.81 1.13 5.13C1.68 5.26 2.205 5.485 2.69 5.795L2.68 5.8C2.745 5.845 2.81 5.89 2.875 5.925L2.91 5.945C3.405 6.305 3.83 6.75 4.165 7.27L5 8.55L5.835 7.275C6.18 6.75 6.61 6.3 7.1 5.945L7.135 5.92C7.18 5.895 7.225 5.865 7.27 5.835L7.265 5.825C7.755 5.5 8.3 5.26 8.87 5.125C8.495 6.81 7.295 8.215 5.66 8.8Z"
      fill={isWhiteIcon ? 'var(--flora--colors-light-light)' : 'black'}
    />
  </svg>
)
